import {
  buildBrandReviewSummaryFromProductBrandReview,
  buildProductReviewSummaryFromProductBrandReview,
} from "@faire/retailer-visitor-shared/lib/buildReviewSummary";
import { useQuery as useProductReviewsQuery } from "@faire/web-api--source/endpoints/www/api/product/productToken/brand-reviews-summary/get-hooks";
import { useMemo } from "react";

export const BRAND_REVIEW_SUMMARY_STALE_TIME = 5 * 60 * 1000; // 5 minutes

export const useBrandReviewSummary = (
  productToken: string,
  enabled: boolean = true
) => {
  const { data: reviewsSummary } = useProductReviewsQuery(productToken, {
    refetchOnMount: false,
    enabled,
    staleTime: BRAND_REVIEW_SUMMARY_STALE_TIME,
  });

  const productReviewSummary = useMemo(() => {
    return buildProductReviewSummaryFromProductBrandReview(reviewsSummary);
  }, [reviewsSummary]);

  const brandReviewSummary = useMemo(() => {
    return buildBrandReviewSummaryFromProductBrandReview(reviewsSummary);
  }, [reviewsSummary]);
  return { brandReviewSummary, productReviewSummary };
};
